import React from "react";

import {
  getWidget,
  getUiOptions,
  getDefaultRegistry,
  hasWidget,
  //@ts-ignore
} from "@rjsf/core/lib/utils";
import { Message } from "semantic-ui-react";
import FieldTemplate from "../Templates/FieldTemplate";
import { WidgetProps } from "@rjsf/core";

function CustomField(props: any) {
  const {
    schema,
    name,
    uiSchema,
    idSchema,
    formData,
    required,
    disabled,
    readonly,
    autofocus,
    onChange,
    onBlur,
    onFocus,
    registry = getDefaultRegistry(),
    rawErrors,
    errorSchema,
    noError,
  } = props;

  const { title, format, description } = schema;
  const { widgets, formContext } = registry;
  let defaultWidget = "text";

  if (format && hasWidget(schema, format, widgets)) {
    defaultWidget = format;
  }

  const { widget = defaultWidget, placeholder = "", ...options } = getUiOptions(
    uiSchema
  );

  let Widget;

  try {
    Widget = getWidget(schema, widget, widgets);
  } catch (error) {
    //   console.info(name, error);
  }

  if (!Widget) {
    return <Message content={`Unsupported widget ${widget}`} />;
  }

  return (
    <FieldTemplate
      // displayLabel={title !== " " && Boolean(options.label || title)}

      rawHelp={options.help}
      disabled={options.disabled}
      required={options.required}
      {...props}
      noError={true}
      displayLabel
      rawDescription={description}
    >
      <Widget
        options={{ ...options }}
        schema={schema}
        uiSchema={uiSchema}
        id={idSchema && idSchema.$id}
        label={title === undefined ? name : title}
        value={formData}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        required={required}
        disabled={disabled}
        readonly={readonly}
        formContext={formContext}
        autofocus={autofocus}
        registry={registry}
        placeholder={placeholder}
        rawErrors={rawErrors}
        errorSchema={errorSchema}
      />
    </FieldTemplate>
  );
}

CustomField.defaultProps = {
  uiSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false,
};

export default CustomField;
